module.exports = __webpack_public_path__ + "img/پیچیده-وشلوغ.877df235.png";